/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_User_DisabledInputs */



/**
* | output |
* | --- |
* | "This account has been disabled." |
*
* @param {Login_Error_User_DisabledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_user_disabled = /** @type {((inputs?: Login_Error_User_DisabledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_User_DisabledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce compte a été désactivé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Konto wurde deaktiviert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo account è stato disabilitato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Этот аккаунт заблокирован.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esta cuenta ha sido deshabilitada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此账户已被禁用。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このアカウントは無効になっています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह खाता बंद कर दिया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esta conta foi desativada.")
	return /** @type {LocalizedString} */ ("This account has been disabled.")
});